import DistrictConfigurationApi from './DistrictConfigurationApi';
export default DistrictConfigurationApi;
